<script setup lang="ts">
defineProps<{
  isSandbox?: boolean
}>()

const { backAction } = useBackAction()
</script>

<template>
  <header class="sticky top-0 z-50 flex flex-col bg-white shadow-[0_1px_4px_0px_rgba(0,0,0,0.1)]">
    <TheSandboxBanner v-if="isSandbox" />
    <div class="flex items-center py-3">
      <div class="flex items-center gap-2 px-4">
        <UiButton
          variant="ghost"
          size="sm"
          icon="docue:chevron-left"
          @click="backAction"
        />
        <slot />
      </div>
      <slot name="right" />
    </div>
  </header>
</template>
